module.exports = __webpack_public_path__ + "static/media/rohit_shidid.dd49fe9e.jpeg";